// Public entry loaded on every page. Pages work without it; keep it small.
document.documentElement.classList.add("js")

const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)")

// Mobile menu is a <details>; the open panel covers the page, so the page behind it is inert.
// Escape and navigation close it, and so does widening past the breakpoint that hides it.
const menu = document.querySelector<HTMLDetailsElement>("[data-menu]")
if (menu) {
  const behind = document.querySelectorAll<HTMLElement>("body > :not([data-header])")
  menu.addEventListener("toggle", () => behind.forEach((element) => (element.inert = menu.open)))
  matchMedia("(min-width: 64rem)").addEventListener("change", (event) => {
    if (event.matches) menu.open = false
  })
  menu.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => (menu.open = false)))
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || !menu.open) return
    menu.open = false
    menu.querySelector("summary")?.focus()
  })
}

// The header gets a hairline once the page scrolls.
const header = document.querySelector<HTMLElement>("[data-header]")
if (header) {
  const update = () => header.classList.toggle("is-scrolled", scrollY > 8)
  addEventListener("scroll", update, { passive: true })
  update()
}

// Sections fade in as they enter the viewport (the CSS only hides them with JS on and motion allowed).
const revealed = document.querySelectorAll<HTMLElement>("[data-reveal]")
if ("IntersectionObserver" in window && !reducedMotion.matches) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add("is-visible")
        observer.unobserve(entry.target)
      }
    },
    { rootMargin: "0px 0px -8% 0px" },
  )
  revealed.forEach((element) => observer.observe(element))
} else {
  revealed.forEach((element) => element.classList.add("is-visible"))
}

// Hero video: plays only when motion is welcome, with a pause button (moving content longer than 5 s).
const video = document.querySelector<HTMLVideoElement>("[data-hero-video]")
const toggle = document.querySelector<HTMLButtonElement>("[data-hero-toggle]")
if (video && toggle && !reducedMotion.matches) {
  const label = toggle.querySelector("span")
  const sync = () => {
    toggle.classList.toggle("is-paused", video.paused)
    if (label) label.textContent = (video.paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause) ?? ""
  }
  video.addEventListener("play", sync)
  video.addEventListener("pause", sync)
  toggle.addEventListener("click", () => (video.paused ? void video.play() : video.pause()))
  video.play().then(() => (toggle.hidden = false), () => undefined)
}

// Copy buttons next to payment details.
document.querySelectorAll<HTMLButtonElement>("[data-copy]").forEach((button) => {
  if (!navigator.clipboard) return
  button.hidden = false
  const text = button.firstChild
  const original = text?.textContent ?? ""
  button.addEventListener("click", async () => {
    await navigator.clipboard.writeText(button.dataset.copy ?? "")
    button.classList.add("is-copied")
    if (text) text.textContent = button.dataset.copied ?? original
    setTimeout(() => {
      button.classList.remove("is-copied")
      if (text) text.textContent = original
    }, 2000)
  })
})
